<template>
  <v-btn
    :loading="loading"
    :disabled="disabled || loading"
    :color="color"
    class="text-capitalize"
    @click="handleClick"
    v-bind="$attrs"
  >
    <slot v-if="!loading">
      {{ defaultText }}
    </slot>
    <span v-else>
      {{ loadingText }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: "AppSubmitBtn",

  props: {
    defaultText: {
      type: String,
      default: "Salvar",
    },
    loadingText: {
      type: String,
      default: "Enviando...",
    },
    color: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    debounceTime: {
      type: Number,
      default: 1000,
    },
  },

  data() {
    return {
      loading: false,
      debounceTimer: null,
    };
  },

  methods: {
    handleClick() {
      if (this.loading) return;

      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.loading = true;

      this.$emit("click");

      this.debounceTimer = setTimeout(() => {
        this.loading = false;
        this.debounceTimer = null;
      }, this.debounceTime);
    },

    stopLoading() {
      this.loading = false;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    },

    startLoading() {
      this.loading = true;
    },
  },

  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
};
</script>
